import Page from "./pages/Page.js";
import Areas from './support/Areas.js';
import AppTitle from './support/AppTitle.js';

import React from 'react';
import { Helmet } from "react-helmet";

const Home = (props) => {
    return (
        <div>
            <Helmet>
                <title>{AppTitle("")}</title>
            </Helmet>
            <Page area={Areas[4]} id={"setting-Home Page"} embed={true} />
        </div >
    );
};

export default Home;